import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Switch,
} from "@material-ui/core";

type Props = {
  groupResults: boolean;
  setGroupResults: (value: boolean) => void;
  showOnlyDataAssets: boolean;
  setShowOnlyDataAssets: (value: boolean) => void;
  showArchived: boolean;
  setShowArchived: (value: boolean) => void;
};

export default function Settings({
  groupResults,
  setGroupResults,
  showOnlyDataAssets,
  setShowOnlyDataAssets,
  showArchived,
  setShowArchived,
}: Props) {
  return (
    <div>
      <FormControl component="fieldset">
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={groupResults}
                onChange={e => setGroupResults(e.target.checked)}
              />
            }
            label="Group Results"
          />
          <FormControlLabel
            control={
              <Switch
                checked={showOnlyDataAssets}
                onChange={e => setShowOnlyDataAssets(e.target.checked)}
              />
            }
            label={showOnlyDataAssets ? "Show Workflows" : "Show Data Assets"}
          />
          <FormControlLabel
            control={
              <Switch
                checked={showArchived}
                onChange={e => setShowArchived(e.target.checked)}
              />
            }
            label={"Show Archived"}
          />
        </FormGroup>
      </FormControl>
    </div>
  );
}
